/**
 * Balanço de tipos de veículos da unidade (cadastro): percentual de oferta por tipo base.
 * Vazio = tipo sem balanço; a soma dos preenchidos deve ser 100, ou nenhum preenchido.
 */

export const BALANCO_SOMA_TOLERANCIA = 0.01;

function percentualValido(v) {
  if (v === '' || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Soma dos percentuais preenchidos, em 2 casas. */
export function balancoTotal(itens) {
  const total = (itens || []).reduce((acc, item) => {
    const n = percentualValido(item && item.percentual);
    return acc + (n == null ? 0 : n);
  }, 0);
  return Math.round(total * 100) / 100;
}

/**
 * 'range' (algum fora de [0, 100]), 'sum' (soma ≠ 100) ou null (válido; sem nenhum
 * percentual ou toda zerada equivale a "sem balanço").
 */
export function balancoPercentuaisErro(itens) {
  const preenchidos = (itens || [])
    .map((item) => percentualValido(item && item.percentual))
    .filter((n) => n != null);
  if (!preenchidos.length) return null;
  if (preenchidos.some((n) => n < 0 || n > 100)) return 'range';
  const total = balancoTotal(itens);
  if (total === 0) return null;
  return Math.abs(total - 100) > BALANCO_SOMA_TOLERANCIA ? 'sum' : null;
}

/**
 * Payload do salvamento. Sem nenhum percentual preenchido (ou tudo zerado) manda [] = sem
 * balanço. Havendo algum, o tipo em branco vai como 0%: é "não ofertar" explícito, e a linha
 * existente impede que a API trate o tipo como novo e refaça a divisão igual.
 */
export function balancoPayload(itens) {
  const lista = (itens || [])
    .map((item) => ({
      id_tipo_veiculo: Number(item.id_tipo_veiculo),
      percentual: percentualValido(item.percentual),
    }))
    .filter((i) => Number.isFinite(i.id_tipo_veiculo) && i.id_tipo_veiculo > 0);
  if (lista.every((i) => i.percentual == null || i.percentual === 0)) return [];
  return lista.map((i) => ({ ...i, percentual: i.percentual == null ? 0 : i.percentual }));
}

/**
 * Junta o catálogo de tipos com o que está salvo na unidade.
 * @param {Array} tipos [{ id_tipo_veiculo, descricao }]
 * @param {Array} salvos [{ id_tipo_veiculo, percentual }]
 */
export function mesclarBalancoComTipos(tipos, salvos) {
  const porTipo = new Map((salvos || []).map((s) => [Number(s.id_tipo_veiculo), s.percentual]));
  return (tipos || []).map((t) => ({
    id_tipo_veiculo: t.id_tipo_veiculo,
    descricao: t.descricao,
    percentual: porTipo.has(Number(t.id_tipo_veiculo)) ? Number(porTipo.get(Number(t.id_tipo_veiculo))) : null,
  }));
}
